import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Button, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch, TextField, Select, InputLabel, FormControl, MenuItem } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import plusFill from "@iconify/icons-eva/plus-fill";
import { asyncRequest } from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import UserInfo from "src/components/common/UserInfo";
import FormItem from "src/components/form-item/FormItem";
import CityPicker from "src/components/CityPicker";
import MyDateRangePicker from "src/components/common/my-date-range-picker/MyDateRangePicker";
import MerchantInfo from "src/components/common/MerchantInfo";

const TABLE_HEAD = [
  // { id: "mid", label: "ID", alignRight: false },
  { id: "name", label: "商户", alignRight: false },
  { id: "total", label: "业绩（元）", alignRight: false },
  // { id: "monthly", label: "月业绩（元）", alignRight: false },
  // { id: "yesterday", label: "昨日业绩（元）", alignRight: false },
  // { id: "today", label: "今日业绩（元）", alignRight: false },
  // { id: "createdAt", label: "创建时间", alignRight: false },
  { id: "isZhiyin", label: "是否直营", alignRight: false },
  { id: "操作" },
];

const moreMenus = [
  // { title: "编辑", icon: iconEdit2 },
];

const sortList = [
  { label: "本年业绩", value: "year" },
  { label: "上月业绩", value: "lastMonth" },
  { label: "本月业绩", value: "month" },
  { label: "上周业绩", value: "lastWeek" },
  { label: "本周业绩", value: "week" },
  { label: "昨日业绩", value: "yesterday" },
  { label: "今日业绩", value: "today" },
];

export default function MerchantRank() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [targetMerchant, setTargetMerchant] = useState(null);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [action, setAction] = useState("");
  const [showYinshou, setShowYinshou] = useState(false);
  const [dailyTotal, setDailyTotal] = useState({});

  const [filter, setFilter] = useState({
    page: 0,
    size: 20,
    search: "",
    provinceId: null,
    cityId: null,
    districtId: null,
    createdAt: null,
    sort: "today",
    order: "DESC",
  });

  useEffect(() => {
    getItems();
    getDailyTotal();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/stats/rankv2",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  async function getDailyTotal() {
    const { data } = await asyncRequest({
      path: "/stats/daily",
      data: filter,
    });

    setDailyTotal(data);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      navigate(`/merchant/edit/${row.mid}`, { state: row });
    }
  };

  async function toggleEnabled(mid) {
    const { data } = await asyncRequest({
      path: "/merchant/toggleEnabled",
      data: {
        mid,
      },
    });

    const item = items.find((it) => it.mid == mid);
    item.isEnabled = !item.isEnabled;
    setItems([...items]);
  }

  const isUserNotFound = items.length === 0;

  return (
    <>
      <Page title="业绩统计">
        <Container maxWidth="2000px">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              业绩统计
            </Typography>
          </Stack>

          <Card>
            <ListToolbar
              filterName={filter.search}
              onFilterName={handleFilterByName}
              onRefresh={() => {
                getItems();
                getDailyTotal();
              }}
            >
              <MyDateRangePicker
                value={filter.createdAt}
                onChange={(val) => {
                  setFilter({
                    ...filter,
                    createdAt: val,
                  });
                }}
              />

              <FormItem title="区域">
                <CityPicker
                  code={filter.provinceId}
                  onSelect={(val) => {
                    console.log(val);
                    setFilter({
                      ...filter,
                      districtId: val.district.id,
                    });
                  }}
                />
              </FormItem>

              <FormControl size="small">
                <InputLabel id="demo-simple-select-label">检索方式</InputLabel>
                <Select
                  // labelId="demo-simple-select-label"
                  // id="demo-simple-select"
                  label="检索方式"
                  value={filter.sort}
                  onChange={(e) => {
                    setFilter({
                      ...filter,
                      sort: e.target.value,
                    });
                  }}
                  style={{ width: 250 }}
                >
                  {sortList.map((item, idx) => (
                    <MenuItem key={idx} value={item.value} name={item}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </ListToolbar>

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <TableRow>
                    <TableCell>
                      {!!filter.createdAt ? (
                        <Stack>
                          <Typography>总业绩：{dailyTotal.total}元（其中直营店{dailyTotal.totalZy}元）</Typography>
                        </Stack>
                      ) : (
                        <Stack>
                          <Typography>年度业绩：{dailyTotal.yearly}元（其中直营店{dailyTotal.yearlyZy}元）</Typography>
                          <Typography>上月业绩：{dailyTotal.lastMonthly}元（其中直营店{dailyTotal.lastMonthlyZy}元）</Typography>
                          <Typography>本月业绩：{dailyTotal.monthly}元（其中直营店{dailyTotal.monthlyZy}元）</Typography>
                          <Typography>昨日业绩：{dailyTotal.yesterday}元（其中直营店{dailyTotal.yesterdayZy}元）</Typography>
                          <Typography>今日业绩：{dailyTotal.today}元（其中直营店{dailyTotal.todayZy || 0}元）</Typography>
                        </Stack>
                      )}
                    </TableCell>
                  </TableRow>
                  <ListHead headLabel={TABLE_HEAD} />
                  <TableBody>
                    {items.map((row) => {
                      const { mid, name, logo, parent, merchant, total, rangli, realname } = row;
                      const { monthly, daily, isZhiyin } = merchant;
                      const isItemSelected = selected.indexOf(realname) !== -1;

                      return (
                        <TableRow hover key={mid} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                          {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, mid)}
                            />
                          </TableCell> */}
                          {/* <TableCell align="left">{mid}</TableCell> */}
                          <TableCell align="left">
                            <MerchantInfo {...merchant} />
                          </TableCell>
                          <TableCell align="left">
                            <Stack>
                              {showYinshou && <Typography>营收：{total}</Typography>}
                              <Typography>让利：{rangli.toFixed(2)}</Typography>
                            </Stack>
                          </TableCell>
                          {/* <TableCell align="left">
                            {monthly && monthly[0] ? (
                              <Stack>
                                {showYinshou && <Typography>营收：{monthly[0].total}</Typography>}
                                <Typography>让利：{monthly[0].rangli}</Typography>
                              </Stack>
                            ) : null}
                          </TableCell>
                          <TableCell align="left">
                            {daily && daily[0] ? (
                              <Stack>
                                {showYinshou && <Typography>营收：{daily[0].total}</Typography>}
                                <Typography>让利：{daily[0].rangli}</Typography>
                              </Stack>
                            ) : null}
                          </TableCell>
                          <TableCell align="left">
                            {today && today[0] ? (
                              <Stack>
                                {showYinshou && <Typography>营收：{today[0].total}</Typography>}
                                <Typography>让利：{today[0].rangli}</Typography>
                              </Stack>
                            ) : null}
                          </TableCell> */}
                          {/* <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell> */}
                          <TableCell align="center">{isZhiyin ? '是' : ''}</TableCell>
                          <TableCell align="right"></TableCell>
                        </TableRow>
                      );
                    })}

                    {/* <TableRow>
                      <TableCell>
                        <Stack>
                          <Typography>年度业绩：{dailyTotal.yearly}元</Typography>
                          <Typography>本度业绩：{dailyTotal.monthly}元</Typography>
                          <Typography>昨日业绩：{dailyTotal.yesterday}元</Typography>
                          <Typography>今日业绩：{dailyTotal.today}元</Typography>
                        </Stack>
                      </TableCell>
                    </TableRow> */}
                    {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                          <SearchNotFound searchQuery={filter.search} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
          </Card>
        </Container>
      </Page>
    </>
  );
}
